import { render, staticRenderFns } from "./NotificationRequestDialog.vue?vue&type=template&id=6aa7cfb4&scoped=true"
import script from "./NotificationRequestDialog.vue?vue&type=script&lang=js"
export * from "./NotificationRequestDialog.vue?vue&type=script&lang=js"
import style0 from "./NotificationRequestDialog.vue?vue&type=style&index=0&id=6aa7cfb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa7cfb4",
  null
  
)

export default component.exports